import format from 'date-fns/format'
import subDays from 'date-fns/subDays'

const sentinelFilter = (json, idIncludes=null) => { 
 // console.log(json)
  const datetimes = json.features.reduce((array, item) => {
    const { id, date } = item.properties
    if (!idIncludes || id.includes(idIncludes)) {
      const datetime = format(subDays(new Date(), 30), 'yyyy-MM-dd')
      if (date >= datetime) {
        array.push(date)
      }
    }
    return array
  }, [])

  return datetimes
}

export default sentinelFilter



// WEBPACK FOOTER //
// ./src/utility/sentinelFilter.js